import Axios from '../Axios';
import { fetchUser } from '../utils/fetchUser';

export const getUsuariosSucursal = async () => {
    try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/usuario/emp?empresa=${userInfo.empresa}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const getUsuariosRol = async (rol,asignacion) => {
    try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/usuario/rol?empresa=${userInfo.empresa}&rol=${rol}&asignacion=${asignacion}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const getMensajeRol = async (rol,asignacion) => {
    try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/usuario/mail?empresa=${userInfo.empresa}&rol=${rol}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const crearUsuarioSucursal = async (usuario) => {
    try {
        const userInfo = fetchUser();
        usuario.empresa = userInfo.empresa;
        
        const {data}  = await Axios.post(
            '/usuario', usuario
        );
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const updateUsuarioSucursal = async (usuario) => {
    try {
        const userInfo = fetchUser();
        usuario.empresa = userInfo.empresa;
        const {data}  = await Axios.patch(
          `/usuario/${usuario._id}`, usuario
        );

        return  data;
      } catch (error) {
        return Promise.reject(error);
      }
  };

  export const updatePasswordUsuario = async (usuario) => {
    try {
        const {data}  = await Axios.patch(
          '/usuario/cambiopassword', usuario
        );

        return  data;
      } catch (error) {
        return Promise.reject(error);
      }
  };

  export const deleteUsuarioSucursal = (Id) => Axios.delete(`/usuario/${Id}`);
